export default "__VITE_ASSET__27cb3bc9__"